import { ol_Feature, ol_geom } from "@omnia/exports/openlayers";

export type OpenLayersGeometryWithArea = ol_geom.Geometry & {
    getArea(): number
}

export function isGeometryWithArea(geom: ol_geom.Geometry): geom is OpenLayersGeometryWithArea {

    if (
        (geom instanceof ol_geom.Polygon)
        || (geom instanceof ol_geom.MultiPolygon)
        || (geom instanceof ol_geom.LinearRing)
    ) {

        return true

    }

}

export function getGeometryArea(geom: ol_geom.Geometry) {

    if (isGeometryWithArea(geom)) {
        return geom.getArea()
    }

}

export function getFeatureArea(feature: ol_Feature) {
    return getGeometryArea(feature.getGeometry())
}
